import Axios from "axios";
import {
  SET_LC_TYPE_LIST,
  UNSET_LC_TYPE_LIST,
} from "@/store/mutation-types";
import { saveUpdateLcType, getLcTypeList } from "@/store/api";

const state = {
  lcTypeList: [],
};

const getters = {
  getLcTypeList(state) {
    return state.lcTypeList;
  },
};

const mutations = {
  [SET_LC_TYPE_LIST](state, data) {
    state.lcTypeList = data;
  },
  [UNSET_LC_TYPE_LIST](state) {
    state.lcTypeList = [];
  },
};

const actions = {
  saveUpdateLcType({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcType, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcTypeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcTypeList, data)
        .then(function (response) {
          commit("SET_LC_TYPE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_TYPE_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

